import React from 'react';

const CheckboxImg = (props) => {
  return (
    <>
      <input
        className={props.className}
        type="checkbox"
        checked={props.checked}
        id={props.id}
        onClick={(event)=>{
          props.handleCheckBox(props.id.split('-')[0], props.id.split('-')[2],event.currentTarget.checked);
        }}
      />
      <label for={props.id}>
        <span>{props.labelName}</span>
      </label>
    </>
  )
}

export default CheckboxImg;